import $ from 'jquery'
import { cca_config } from '../../CCA_ENV_CONF/env'
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import excel from 'vue-excel-export'
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';

 
Vue.use(excel)
// import moment from 'moment';
Vue.use(VueHtml2pdf)

export const utilMixins = {
    components: {
        EnteteBonEtFacture
    },

    data() {
        return {
            assets_path: cca_config.C_URL+cca_config.C_URL_CAISSE_ASSET,
            clinique_assets_path: cca_config.C_URL+cca_config.C_URL_ASSET,

            base_url_clinique: cca_config.C_CLINIQUE_FE_URL,
            base_url_caisse: cca_config.C_CAISSE_FE_URL,
            base_url_stock: cca_config.C_STOCK_FE_URL,
            base_url_rh: cca_config.C_RH_FE_URL,

            default_country_code: cca_config.COUNTRY_CODE,
            ville: cca_config.VILLE,

            foot_1: "",
            foot_2: "",
            foot_3: '',
            status_is_loading: true,
            token: "gg",

            list_months: [
                { id: '', lib: "Choisir" }, 
                { id: 1, lib: "Janvier" }, { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" }, { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" }, { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" }, { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" }, { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" }, { id: 12, lib: "Décembre" },
            ],
            current_date: new Date(),
            is_printing: false,
            is_sfe: cca_config.IS_SFE,
            can_set_pac: cca_config.CAN_SET_PAC,
            currency_lang: cca_config.CURRENCY_LANG,
            has_two_currencies: cca_config.HAS_TWO_CURRENCIES,
            principal_currency: cca_config.PRINCIPAL_CURRENCY,
            secondary_currency: cca_config.SECONDARY_CURRENCY,
            currency_info: {
                principal_currency: 'F.CFA',
                secondary_currency: '',
                rate: ''
            },

            nom_clinique: '',
            logo_clinique: '',
            has_info: false
        };
    },


    created() {
        document.title = cca_config.VUE_APP_NAME;
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            let m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        config_info_clinique() {
            return this.$store.getters["config_info_clinique"];
        },
    },

    mounted() { 
        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }

        this.checkInfoClinique()
    },

    methods: {
        checkInfoClinique() {
            this.nom_clinique = cca_config.NOM_CLINIQUE
            this.logo_clinique = ''
            this.has_info = true
            // if (
            //     (this.config_info_clinique.nom && this.config_info_clinique.nom != '') && 
            //     (this.config_info_clinique.logo && this.config_info_clinique.logo != '')
            // ) {
            //     this.nom_clinique = this.config_info_clinique.nom
            //     this.logo_clinique = this.config_info_clinique.logo
            //     this.has_info = true
            // }
        },

        formatDateToDateHour(given_date) {
            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            month = month < 10 ? "0" + month : month;

            let d = date.getDate();
            d = d < 10 ? "0" + d : d;

            only_date = d + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();

            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + "h" + c_minute;

            return only_date + " à " + only_hour;
        },

        formatDateToDmY(given_date) {
            let only_date = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            month = month < 10 ? "0" + month : month;

            let d = date.getDate();
            d = d < 10 ? "0" + d : d;

            only_date = d + "/" + month + "/" + date.getFullYear();

            return only_date;
        },

        getCurrentDate() {
            const date = new Date()
            let curr_month = date.getMonth() + 1
            curr_month = (curr_month < 10)?'0'+curr_month:curr_month

            let curr_day = date.getDate()
            curr_day = (curr_day < 10)?'0'+curr_day:curr_day

            const curr_date = curr_day + '/' + curr_month + '/' + date.getFullYear()
            return curr_date
        },

        setDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        /**
         * Format input to only digit
         * @param {*} selector
         */
        async onlyDigits(selector) {
            $("#" + selector).val(
                $("#" + selector)
                    .val()
                    .replace(/[^0-9]+/g, "")
            );
        },

        formatCurrency(num) {
            return new Number(num).toLocaleString(this.currency_lang);
        },

        successToast: function (message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-primary",
                type: "success",
                position: "top-center",
            });
        },

        warningToast: function (message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-warning",
                type: "warning",
                position: "top-center",
            });
        },

        dangerToast: function (message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-danger",
                type: "danger",
                position: "top-center",
            });
        },

        goTo(url) {
            this.$router.push({ path: url });
        },

        printPDF(ref) {
            this.is_printing = true
            if (ref === undefined) {
                this.$refs.html2Pdf.generatePdf()
            } else {
                this.$refs.ref_html2Pdf.generatePdf()
            }
        },

        async beforeDownload({ html2pdf, options, pdfContent }, format, water_mark_text='') {
            const newOptions = {
                ...options,
                pagebreak: {
                    mode: ['avoid-all']
                },
            }

            
            await html2pdf().set(newOptions).from(pdfContent).set(
                {
                    margin: [0.2, 0, 1, 0],
                    image: { type: 'jpeg', quality: 0.98 }
                }
            ).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                this.getFooter()

                const page_size = pdf.internal.pageSize.getWidth()
                const page_height = pdf.internal.pageSize.getHeight()

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)

                    // pdf.setFont('Arial', 'B', 8)
                    if (format == 'a4') {
                        pdf.setFontSize(10)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    } else if (format == 'a5') {
                        pdf.setFontSize(8)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.7), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_3, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    }

                    pdf.setFontSize(10)
                    pdf.text(water_mark_text, (page_size - 0.4), (page_height - 0.1), {align: 'right'})

                } 
            }).save().then(() => {
                this.is_printing = false
            })
        },

        

        getFooter() {
            // EPHATA
            this.foot_1 = cca_config.FOOT_1
            this.foot_2 = cca_config.FOOT_2
        },

        hasDownloaded() { },

        onProgress() { },

        startPagination() { },

        hasPaginated() { },

        /**
         * Validate a string not to be empty
         * @param {*} value 
         */
        validateStringNotEmpty(value) {
            if (typeof value  === 'string') {
                if (value.trim().length === 0) {
                    return true
                }
            }

            if (value == null) {
                return true
            }
            return false
        },

        transformToNumber(value) {
            return +value;
        },

        cleanNumber(value) {
            if (this.validateStringNotEmpty(value)) {
                return ''
            }
            value = this.transformToNumber(value)
            if (!this.validateNumber(value)) {
                return ''
            }
            return value
        },

        validateNumber(number) {
            if (isNaN(number) || typeof number !== 'number') {
              return false
            }
            return true
        },

        isObjectEmpty(obj) {
            return Object.keys(obj).length === 0;
        },

        /**
         * Check that the insurance contract is valid
         * @returns 
         */
        InsuranceIsValid(assurance_est_expire) {
            if (assurance_est_expire == 1) {
                return false
            }
            return true
        },

        /**
         * Check if number is greater than 0
         * @param {*} amount 
         */
        checkIfNumberGreaterThanZero(amount) {
            amount = +amount
            if (amount == 0) {
                return false
            }
            return true
        },

        /**
         * Check if the cash register is opened.
         * If close redirect to dashboard. 
         */
        checkRegisterCashStatus(compte_id) {
            this.status_is_loading = true
            const data = {
                compte_id: compte_id
            }

            this.$store.dispatch('getEtatOuvertureCaisse', data).then(() => {
                if (this.etat_ouverture_caisse.close_status == 1 || this.etat_ouverture_caisse.length == 0) {         // CLOSED
                    this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
                }
                this.status_is_loading = false
            })
        },

        toggleCollapse(selector) {
            const el = document.getElementById(selector)
            const hd = document.querySelectorAll(".section-box")
            
            if (hd != null) {
                for (let i = 0; i < hd.length; ++i) {
                    hd[i].classList.remove('show');
                }
            }
            
            el.classList.add('show')
        },

        capitalizeFirstLetter(c) {
            let s = c.charAt(0)
            s = s.toUpperCase()+c.slice(1)
            return s
        },

        capitalizeStr(str) {
            str = str.toUpperCase()
            return str
        },

        cutString(value, len) {
            let str_value = value.substr(0, len)
            return str_value
        },

        shortenString(value) {
            let shorten_string = value
            // let len = value.length

            // if (len > s_len) {
            //     shorten_string = value.substr(0, s_len)+'...'
            // }

            return shorten_string
        },

        setLibellePrestation(type_prestation) {
            let libelle = '';

            switch (type_prestation) {
                case 'acte':
                    libelle = 'Acte.s';
                    break;
                case 'admission':
                    libelle = 'Admission.s';
                    break;
                case 'analyse':
                    libelle = 'Analyse.s';
                    break;
                case 'apport_social':
                    libelle = 'Apport social';
                    break;
                case 'bon_consultation':
                    libelle = 'Bon de consultation';
                    break;
                case 'consultation':
                    libelle = 'Consultations';
                    break;
                case 'chambre':
                    libelle = 'Chambre.s';
                    break;
                case 'consommable':
                    libelle = 'Consommable.s';
                    break;
                case 'consommable_bon':
                    libelle = 'Consommables de bon de consultation';
                    break;
                case 'depense':
                    libelle = 'Dépense.s';
                    break;
                case 'examen':
                    libelle = 'Examen.s';
                    break;
                case 'medicament':
                    libelle = 'Médicament.s';
                    break;
                case 'observation':
                    libelle = 'Observation.s';
                    break;
                case 'bilan_sante':
                    libelle = 'Bilan de santé';
                    break;
                case 'chirurgie':
                    libelle = 'Chirurgies';
                    break;
                case 'reglement_dette':
                    libelle = 'Règlement de dettes';
                    break;
            }
            return libelle;
        },


        setLibelleGroupTaxation(key) {
            let libelle = ''
            switch(key) {
                case 'a':
                    libelle = 'A- EXONERE'
                    break;
                case 'b':
                    libelle = 'B- TAXABLE 18%'
                    break;
                case 'c': 
                    libelle = 'C- EXPORTATION'
                    break;
                case 'd': 
                    libelle = 'D- TVA REGIME D\'EXCEPTION 18%'
                    break;
                case 'e':
                    libelle = 'E- REGIME TPS'
                    break;
                case 'f': 
                    libelle = 'F- RESERVE'
                    break;
                case 'aibA':
                    libelle = 'AIB (1%)'
                    break;
                case 'aibB':
                    libelle = 'AIB (5%)'
                    break;
                case 'n_a':
                    libelle = 'AIB (N/A)'
                    break;
            }
            return libelle
        },

        /**
         * Set UID for an array of prestation
         * @param {Array} prestations  
         */
        setPrestationUID(prestations) {
            prestations.forEach((analyse, index) => {
                const tm = new Date()
                let dtime = ''+tm.getTime()
                dtime = this.shuffle(dtime)
                let tmp_uid = analyse.nom
                tmp_uid = tmp_uid.replace(" ", "_")
                tmp_uid = tmp_uid.replace("/", "_")
                tmp_uid = tmp_uid.toLowerCase()+''+dtime
                tmp_uid = tmp_uid.replace("  ", "_")
                tmp_uid = tmp_uid.replace(" ", "_")
                prestations[index]['uid'] = tmp_uid
            });
            return prestations
        },

        /**
         * Set UID for a single prestation
         * @param {*} libelle 
         */
        setSinglePrestationUID(libelle) {
            const tm = new Date()
            let dtime = ''+tm.getTime()
            dtime = this.shuffle(dtime)
            let tmp_uid = libelle
            tmp_uid = tmp_uid.replace(" ", "_")
            tmp_uid = tmp_uid.replace("/", "_")
            tmp_uid = tmp_uid.toLowerCase()+''+dtime
            tmp_uid = tmp_uid.replace("  ", "_")
            tmp_uid = tmp_uid.replace(" ", "_")
            
            return tmp_uid
        },

        /**
         * Shuffle string
         * @param {*} s 
         * @returns 
         */
        shuffle(s) {
            var arr = s.split('');           // Convert String to array
            
            arr.sort(function() {
              return 0.5 - Math.random();
            });  
            s = arr.join('');                // Convert Array to string
            return s;                        // Return shuffled string
        },

        /**
         * Remove special character from string
         */
        removeAccents(strAccents){
            strAccents = strAccents.split('');
            let strAccentsOut = new Array();
            let strAccentsLen = strAccents.length;
            let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
            let accentsOut = [
                'A','A','A','A','A','A','a','a','a','a','a','a','O','O','O','O','O','O','O','o',
                'o','o','o','o','o','E','E','E','E','e','e','e','e','e','C','c','D','I','I','I','I',
                'i','i','i','i','U','U','U','U','u','u','u','u','N','n','S','s','Y','y','y','Z','z'
            ];
            for (let y = 0; y < strAccentsLen; y++) {
                if (accents.indexOf(strAccents[y]) != -1) {
                    strAccentsOut[y] = accentsOut[accents.indexOf(strAccents[y])];
                }
                else
                    strAccentsOut[y] = strAccents[y];
            }
            strAccentsOut = strAccentsOut.join('');
            return strAccentsOut;
        }, 

        async checkInternetConnection() {
            try {
              const response = await fetch('https://www.google.com', { mode: 'no-cors' });
              if (response.ok || response.type === 'opaque') {
                return true
              } else {
                return false
              }
            } catch (error) {
              return false
            }
        },

        // getCurrencyInfo() {
        //     this.$store.dispatch('getConfigInfoClinique', 'currency').then((response) => {
        //         this.currency_info = {
        //             principal_currency: response.principal_currency,
        //             secondary_currency: response.secondary_currency,
        //             rate: response.rate
        //         }
        //     })
        // },

        formatPercentage(value) {
            const number = Number(value)
            if (Number.isNaN(number)) {
                return '0.00'
            }
            return number.toFixed(2)
        },

        convertDataTypeToLibelle(data_type) {
            let libelle = ''
            switch (data_type) {
                case 'consultation':
                    libelle = 'Consultations';
                    break;
                case 'acte':
                    libelle = 'Actes';
                    break;
                case 'admission':
                    libelle = 'Admissions';
                    break;
                case 'analyse':
                    libelle = 'Analyses';
                    break;
                case 'apport_social':
                    libelle = 'Apport social';
                    break;
                case 'bon_consultation':
                    libelle = 'Bon de consultation';
                    break;
                case 'chambre':
                    libelle = 'Chambres';
                    break;
                case 'consommable':
                    libelle = 'Consommables';
                    break;
                case 'consommable_bon':
                    libelle = 'Consommables de bon de consultation';
                    break;
                case 'depense':
                    libelle = 'Dépenses';
                    break;
                case 'examen':
                    libelle = 'Examens';
                    break;
                case 'medicament':
                    libelle = 'Médicaments';
                    break;
                case 'observation':
                    libelle = 'Observations';
                    break;
                case 'chirurgie':
                    libelle = 'Chirurgies';
                    break;
                case 'bilan_sante':
                    libelle = 'Bilan de santé';
                    break;
                case 'reglement_dette':
                    libelle = 'Règlement de dettes';
                    break;
                case 'autre_prestation':
                    libelle = 'Autres';
                    break;
            }
            return libelle;
        },

        checkIfCanPreview(filename) {
            let can_view = false

            if (filename != '') {
                if (
                    filename.includes('pdf') || filename.includes('png') || 
                    filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                    filename.includes('jpg') || filename.includes('JPG') 
                ) {
                    can_view = true
                }
            }
            return can_view
        }
    }
};

// Export a separate token variable for global access
export let token = ""; 

// Function to update the token
export function setToken(newToken) {
    token = newToken;
}